import { render, staticRenderFns } from "./KarigarManagement.vue?vue&type=template&id=198d4919&"
import script from "./KarigarManagement.vue?vue&type=script&lang=js&"
export * from "./KarigarManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports